document.addEventListener('DOMContentLoaded', function () {

    // --- 初期表示用クラス ------
    if (document.querySelector('.js-load')) {
        const TIME_PAUSE = 5000;
        const TIME_BLANK = 2300;

        const wrapper = document.querySelector('.js-load');
        wrapper.classList.add('is-loaded', 'is-show');
        setInterval(function () {
            wrapper.classList.add('is-hide');
            setTimeout(function () {
                wrapper.classList.remove('is-hide');
            }, TIME_BLANK);
        }, TIME_PAUSE + TIME_BLANK);

    }
});